import React from 'react';
import ReactMarkdown from 'react-markdown';

import styles from './Markdown.module.css';

interface MarkdownProps {
  children: string;
  className?: string;
}

const Markdown: React.FC<MarkdownProps> = ({ children, className = '' }) => {
  return (
    <ReactMarkdown
      className={`${styles.markdown} ${className}`}
      components={{
        h1: ({ node, ...props }) => <h1 className={styles.h1} {...props} />,
        h2: ({ node, ...props }) => <h2 className={styles.h2} {...props} />,
        h3: ({ node, ...props }) => <h3 className={styles.h3} {...props} />,
        h4: ({ node, ...props }) => <h4 className={styles.h4} {...props} />,
        h5: ({ node, ...props }) => <h5 className={styles.h5} {...props} />,
        h6: ({ node, ...props }) => <h6 className={styles.h6} {...props} />,
        blockquote: ({ node, ...props }) => (
          <blockquote className={styles.blockquote} {...props} />
        ),
        ol: ({ node, ...props }) => <ol className={styles.ol} {...props} />,
        ul: ({ node, ...props }) => <ul className={styles.ul} {...props} />,
        li: ({ node, ...props }) => <li className={styles.li} {...props} />,
        code({ node, inline, className, children, ...props }) {
          if (!inline) {
            return (
              <pre className={styles.codeblock} {...props}>
                <code className={styles.code}>{children}</code>
              </pre>
            );
          } else {
            return (
              <code className={`${styles.code} ${className || ''}`} {...props}>
                {children}
              </code>
            );
          }
        },
        strong: ({ node, ...props }) => (
          <strong className={styles.bold} {...props} />
        ),
        em: ({ node, ...props }) => <em className={styles.italic} {...props} />,
        u: ({ node, ...props }) => (
          <u className={styles.underline} {...props} />
        ),
        p: ({ node, ...props }) => <p className={styles.p} {...props} />,
        pre: ({ node, ...props }) => <pre className={styles.pre} {...props} />,
        span: ({ node, ...props }) => (
          <span className={styles.monospace} {...props} />
        ),
      }}
    >
      {children}
    </ReactMarkdown>
  );
};

export default Markdown;
